import { createContext } from 'preact-compat'
import { page404WithoutContext } from './page404WithoutContext'
import { PageContextWithURL } from './types'
// eslint-disable-next-line import/prefer-default-export
export const CurrentPageContext = createContext<PageContextWithURL>({
  ...page404WithoutContext,
  fullUrl: new URL('http://127.0.0.1/404')
})
